enum Routes {
  Home = '/',
  RootPrismicPages = '/:uid',

  SignUpRegister = '/sign-up/register',
  SignUpIdentity = '/sign-up/identity',
  SignUpPersonalInformation = '/sign-up/identity/personal-information',
  SignUpAreYouACompany = '/sign-up/identity/are-you-a-company',
  SignUpCompanyInformation = '/sign-up/identity/company-information',
  SignUpFavoriteIndustries = '/sign-up/favorite-industries',
  SignUpFinancialSituation = '/sign-up/financial-situation',
  SignUpInvestmentKnowledgeQuestionnaire = '/sign-up/investment-knowledge-questionnaire',
  SignUpInvestmentGoals = '/sign-up/investment-knowledge-questionnaire/investment-goals',
  SignUpStartupInvestmentExperience = '/sign-up/investment-knowledge-questionnaire/startup-investment-experience',
  SignUpInvestmentExperience = '/sign-up/investment-knowledge-questionnaire/investment-experience',
  SignUpRiskAwareness = '/sign-up/investment-knowledge-questionnaire/risk-awareness',
  SignUpQuestionnaireResults = '/sign-up/investment-knowledge-questionnaire/results',
  SignUpIdentityValidation = '/sign-up/identity-validation',
  SignUpThankYou = '/sign-up/thank-you',
  // Page "résolveur" : redirige vers la 1re étape incomplète du dossier (redirectToSuitableSignUpFunnelStep).
  CompleteFolder = '/complete-folder',

  // Ré-acceptation des CGU pour un compte connecté "legacy" (acceptedRisksDate NULL).
  AcceptCgu = '/accept-cgu',

  SignIn = '/sign-in',
  Projects = '/projects',
  Invest = '/investir',
  HowProjectWorks = '/how-it-works',
  Project = '/projects/:slug',
  GetFunded = '/get-funded',
  ForgotPassword = '/forgot-password',
  ResetPassword = '/reset-password',
  ProjectInvestAmount = '/investments/:id/invest/amount',
  ProjectInvestInvestMode = '/investments/:id/invest/mode',
  ProjectInvestPaymentMethod = '/investments/:id/invest/payment-method',
  ProjectInvestSummary = '/investments/:id/invest/summary',
  ProjectInvestPayment = '/investments/:id/invest/payment',
  ProjectInvestSignSubscriptionWarrant = '/investments/:id/invest/sign-subscription-warrant',
  ProjectInvestValidation = '/investments/:id/invest/validation',
  Portfolio = '/account/portfolio',
  LegalEntityDetail = '/account/portfolio/legal-entity/:id',
  LegalEntityDocument = '/account/portfolio/document/:id',
  TransactionDetail = '/account/transactions/:transactionId',
  InvestmentVehicleExemptTaxCertificate = '/account/portfolio/legal-entity/:legalEntityId/investment/:vehicleId/exempt-tax-certificate',
  InvestmentVehicleInvestmentBill = '/account/portfolio/legal-entity/:legalEntityId/investment/:vehicleId/investment/:investmentId/bill',
  InvestmentVehicleInvestmentSubscriptionReport = '/account/portfolio/legal-entity/:legalEntityId/investment/:vehicleId/investment/:investmentId/subscription-report',
  GeneralMeetingAnnualAccounts = '/account/portfolio/general-meeting/:generalMeetingId/annual-accounts',
  GeneralMeetingChairmanReportAndResolutions = '/account/portfolio/general-meeting/:generalMeetingId/chairman-report-and-resolutions',
  GeneralMeetingMinutes = '/account/portfolio/general-meeting/:generalMeetingId/minutes',
  GeneralMeetingSignProxy = '/account/portfolio/general-meeting/:generalMeetingId/proxy-signature',
  GeneralMeetingProxyToSign = '/account/portfolio/general-meeting/:generalMeetingId/proxy-to-sign',
  LegalEntityShareOwnershipCertificate = '/account/portfolio/legal-entity/:legalEntityId/shareholding-proof',
  Withdraw = '/account/wallet/withdraw',
  Supply = '/account/wallet/supply',
  SupplyTransaction = '/mon-espace/wallet/alimenter/:supplyTransactionId',
  SupplyTransactionSuccess = '/mon-espace/wallet/alimenter/:supplyTransactionId/success',
  Rib = '/account/rib',
  FiscalSituation = '/account/fiscal-situation',
  FiscalSituationRibFile = '/account/fiscal-situation/rib-file',
  FiscalSituationAttestation = '/account/fiscal-situation/attestation/:kind',
  Company = '/account/company',
  FavoriteProjects = '/account/favorite',
  Profile = '/account/details',
  Transactions = '/account/transactions',
  Wallet = '/account/wallet',
  Guides = '/guides',

  // Mon Espace V2 (refonte espace investisseur) — coexiste avec /account pendant la migration.
  Espace = '/mon-espace',
  EspaceParticipations = '/mon-espace/participations',
  EspaceParticipationCampaign = '/mon-espace/participations/collecte/:slug',
  EspaceParticipationHolding = '/mon-espace/participations/holding/:id',
  EspaceParticipationPending = '/mon-espace/participations/promesse/:investmentId',
  EspaceFavorites = '/mon-espace/favoris',
  EspaceWallet = '/mon-espace/wallet',
  EspaceWalletSupply = '/mon-espace/wallet/alimenter',
  EspaceWalletWithdraw = '/mon-espace/wallet/retirer',
  EspaceTransactionDetail = '/mon-espace/wallet/transaction/:transactionId',
  EspaceAccount = '/mon-espace/compte',
  EspaceAccountInfos = '/mon-espace/compte/informations',
  EspaceAccountEmail = '/mon-espace/compte/preferences-email',
  EspaceAccountInterests = '/mon-espace/compte/centres-interet',
  EspaceAccountRib = '/mon-espace/compte/rib',
  EspaceAccountFiscal = '/mon-espace/compte/situation-fiscale',
  EspaceAccountDocuments = '/mon-espace/compte/documents',
  EspaceAccountSecurity = '/mon-espace/compte/securite',
  // Mise à jour KYC Lemonway (compte restreint) : page serveur qui ouvre le flux Lemonway.
  EspaceKycUpdate = '/mon-espace/kyc-update',
}

export default Routes;
